export default __webpack_public_path__ + "static/media/welcome-bg.113d01e9.jpg";